import { createContext, useContext } from "react";
import { CommericalAction } from "../types";



//MenuItem
interface CommercialMenuItemCtxInterface {
  updateStatisfyMenusMandatory: (satisfied: boolean) => void;
}
export const CommercialMenuItemCtx = createContext<CommercialMenuItemCtxInterface>(
  {} as CommercialMenuItemCtxInterface
);
export const useCommercialMenuItemContext = () => useContext(CommercialMenuItemCtx);

//Menus
interface CommercialMenusCtxInterface {
  resetMenusAvailabilities: () => void;
  selectedMenusIds: Array<number>;
  performAction: (action: CommericalAction, details: { [menuId: number]: number | undefined }) => void
  menusAvailabilities: { [key: number]: boolean };
}
export const CommercialMenusCtx = createContext<CommercialMenusCtxInterface>(
  {} as CommercialMenusCtxInterface
);
export const useCommercialMenusContext = () => useContext(CommercialMenusCtx);

//Menu
interface CommercialMenuCtxInterface {
  updateUnavailable: (unavailable: boolean) => void;
}
export const CommercialMenuCtx = createContext<CommercialMenuCtxInterface>(
  {} as CommercialMenuCtxInterface
);
export const useCommercialMenuContext = () => useContext(CommercialMenuCtx);


//voucher
interface DetailsVoucherCtxInterface {
  updateDisabledBtnFromVoucher: (disabled: boolean) => void;
  updateValidVoucherCode: (loading: boolean) => void;
}
export const DetailsVoucherCtx = createContext<DetailsVoucherCtxInterface>(
  {} as DetailsVoucherCtxInterface
);
export const useDetailsVoucherContext = () => useContext(DetailsVoucherCtx);
